import angular from "angular";

export default function UploadServiceProvider() {
  this.$get = (Upload) => {
    'ngInject';

    function UploadService() {

      const self = this;

      const userAvatar = (url) => {
        return (image, cropArea, onSuccess, onError) => {
          return uploadImage(image, url, "POST", null, onSuccess, onError, null, {
            original: {
              quality: 0.8,
              width: 1000,
              height: 1000
            },
            thumbnail: {
              crop: cropArea
            }
          });
        };
      };

      const uploadServiceProviderImage = (url) => {
        return (image, onSuccess, onError, onProgress) => {
          const uploadRequest = {
            image: image
          };

          return uploadFile(url, uploadRequest, "POST", onSuccess, onError, onProgress);
        };
      }

      const uploadBicycleImage = (url) => {
        return (image, onSuccess, onError, onProgress) => {
          const uploadRequest = {
            image: image
          };

          return uploadFile(url, uploadRequest, "POST", onSuccess, onError, onProgress);
        };
      }

      const uploadRequestImage = (url) => {
        return (image, onSuccess, onError, onProgress) => {
          const uploadRequest = {
            image: image
          };

          return uploadFile(url, uploadRequest, "POST", onSuccess, onError, onProgress);
        };
      }

      const uploadApplicationIcon = (url) => {
        return (image, onSuccess, onError, onProgress) => {
          const uploadRequest = {
            image: image
          };

          return uploadFile(url, uploadRequest, "POST", onSuccess, onError, onProgress);
        };
      }

      const uploadDocument = (url) => {
        return (document, onSuccess, onError, onProgress) => {
          const uploadRequest = {
            document: document
          };

          return uploadFile(url, uploadRequest, "POST", onSuccess, onError, onProgress);
        };
      }

      const uploadOrganisationImage = (url) => {
        return (image, cropArea, onSuccess, onError) => {
          return uploadImage(image, url, 'POST', null, onSuccess, onError, null, {
            original: {
              quality: 0.8,
              width: 1000,
              height: 1000
            },
            thumbnail: {
              crop: cropArea
            }
          });
        };
      };

      const uploadImage = (image, url, method, onResize, onSuccess, onError, onProgress, imageOptions) => {
        const img = new Image();
        img.onload = () => {
          imageOptions.original.width = Math.min(img.width, imageOptions.original.width);
          imageOptions.original.height = Math.min(img.height, imageOptions.original.height);
          Upload.resize(image, imageOptions.original)
            .then((resizedFile) => {
              if (onResize) {
                onResize(resizedFile);
              }
              const uploadRequest = {
                image: resizedFile
              };
              if (imageOptions.thumbnail && imageOptions.thumbnail.crop) {
                calculateCropArea(image, resizedFile, imageOptions.thumbnail, () => {
                  uploadRequest.thumbnail = angular.toJson(imageOptions.thumbnail);
                  uploadFile(url, uploadRequest, method, onSuccess, onError, onProgress);
                });
              } else if (imageOptions.thumbnail) {
                uploadRequest.thumbnail = angular.toJson(imageOptions.thumbnail);
                uploadFile(url, uploadRequest, method, onSuccess, onError, onProgress);
              } else {
                uploadFile(url, uploadRequest, method, onSuccess, onError, onProgress);
              }
            });
        };

        img.onerror = () => {
          if (onError) {
            onError();
          }
        };

        img.src = URL.createObjectURL(image);
      };

      const calculateCropArea = (originalFile, resizedFile, thumbnailConfig, callback) => {
        getImageDimensions(originalFile, (oW, oH) => {
          getImageDimensions(resizedFile, (rW, rH) => {
            const wRatio = rW / oW;
            const hRatio = rH / oH;

            const cropArea = thumbnailConfig.crop;

            thumbnailConfig.crop = {
              x: Math.floor(cropArea.x * wRatio),
              y: Math.floor(cropArea.y * hRatio),
              w: Math.floor(cropArea.w * wRatio),
              h: Math.floor(cropArea.h * hRatio)
            };

            if (thumbnailConfig.width && thumbnailConfig.height) {
              thumbnailConfig.width = Math.min(thumbnailConfig.width, thumbnailConfig.crop.w);
              thumbnailConfig.height = Math.min(thumbnailConfig.height, thumbnailConfig.crop.h);

              const scaleX = thumbnailConfig.width / thumbnailConfig.crop.w;
              const scaleY = thumbnailConfig.height / thumbnailConfig.crop.h;

              thumbnailConfig.scale = Math.max(scaleX, scaleY);
            }

            callback(thumbnailConfig);
          });
        });
      };

      const getImageDimensions = (image, callback) => {
        const img = new Image();
        const url = URL.createObjectURL(image);

        img.onload = () => {
          callback(img.width, img.height);
        };

        img.src = url;
      };

      const importBicycles = (url) => {
        return (uploadRequest, onSuccess, onError, onProgress) => {
          return uploadFile(url, uploadRequest, "POST", onSuccess, onError, onProgress);
        };
      };

      const uploadFile = (url, data, method, onSuccess, onError, onProgress) => {
        if (!method) {
          method = 'POST';
        }

        Upload.upload({
          url: url,
          method: method,
          data: data
        }).success(response => {
          if (onSuccess) {
            onSuccess(response);
          }
        }).error(error => {
          if (onError) {
            onError(error);
          }
        }).progress(progress => {
          if (onProgress) {
            onProgress(progress);
          }
        });
      };

      self.bicycleOwner = () => {
        return {
          uploadAvatar: userAvatar('/api/v1/fo/bicycle-owner/profile/avatar'),
          uploadBicycleImage: uploadBicycleImage('/api/v1/fo/bicycle-owner/bicycles/images'),
          uploadRequestImage: uploadRequestImage('/api/v1/fo/bicycle-owner/requests/images')
        }
      }

      self.serviceProvider = () => {
        return {
          uploadAvatar: userAvatar('/api/v1/fo/service-provider/profile/avatar'),
          uploadGalleryImage: uploadServiceProviderImage('/api/v1/fo/service-provider/profile/images'),
          uploadBicycleImage: uploadBicycleImage('/api/v1/fo/service-provider/bicycles/images'),
          uploadRequestImage: uploadRequestImage('/api/v1/fo/service-provider/requests/images'),
          uploadDocument: uploadDocument('/api/v1/fo/service-provider/settings/document')
        }
      }

      self.organisationOwner = (id) => {
        return {
          uploadOrganisationImage: uploadOrganisationImage('/api/v1/fo/organisation-owner/organisations/' + id + '/images'),
          uploadBicycleGroupImage: uploadOrganisationImage('/api/v1/fo/organisation-owner/' + id + '/bicycle-groups/images'),
          uploadBicycleImage: uploadBicycleImage('/api/v1/fo/organisation-owner/' + id + '/bicycles/images'),
          uploadRequestImage: uploadRequestImage('/api/v1/fo/organisation-owner/' + id + '/requests/images'),
          importBicycles: importBicycles('/api/v1/fo/organisation-owner/' + id + '/bicycles/import')
        }
      }

      self.admin = (id) => {
        return {
          uploadAvatar: userAvatar('/api/v1/fo/admin/profile/avatar'),
          uploadUserAvatar: userAvatar('/api/v1/fo/admin/users/' + id + '/avatar'),
          uploadServiceProviderImage: uploadServiceProviderImage('/api/v1/fo/admin/service-providers/' + id + '/images'),
          uploadOrganisationImage: uploadOrganisationImage('/api/v1/fo/admin/organisations/' + id + '/images'),
          uploadBicycleImage: uploadBicycleImage('/api/v1/fo/admin/bicycles/images'),
          uploadBicycleGroupImage: uploadOrganisationImage('/api/v1/fo/admin/bicycle-groups/' + id + '/images'),
          uploadRequestImage: uploadRequestImage('/api/v1/fo/admin/requests/images'),
          uploadApplicationIcon: uploadApplicationIcon('/api/v1/fo/admin/applications/icon'),
          importBicycles: importBicycles('/api/v1/fo/admin/bicycles/import'),
        }
      }

    }

    return new UploadService();
  };
}
